import { isElectricityOnly, isGasOnly } from "@/features/subscription"
import { type OnboardingFormValues } from "../../wizard/types/onboardingFormValues"
import { OnboardingPostQuoteEvents } from "../constants/onboardingPostQuoteEvents"
import { type OnboardingDataLayerEvent } from "../types/onboardingDataLayerEvent"

const formatProductAmount = (formValues: OnboardingFormValues) => {
    const electricityAmount = formValues.electricity?.quotedProduct?.monthlyAmount || 0
    const gasAmount = formValues.gas?.quotedProduct?.monthlyAmount || 0

    return { total_amount: Math.ceil(electricityAmount + gasAmount) / 100 }
}

const formatProductCodes = (formValues: OnboardingFormValues) => {
    const electricityOffer = formValues.electricity?.quotedProduct?.product?.code
    const gasOffer = formValues.gas?.quotedProduct?.product?.code

    if (isElectricityOnly(formValues.selectedEnergyTypes)) {
        return { electricity_offer: electricityOffer }
    }

    if (isGasOnly(formValues.selectedEnergyTypes)) {
        return { gas_offer: gasOffer }
    }

    return { electricity_offer: electricityOffer, gas_offer: gasOffer }
}

const formatInvoiceUploadSaving = (formValues: OnboardingFormValues) => {
    return {
        yearly_saving: formValues.electricity.yearlySaving,
        is_significant: formValues.electricity.isSignificant,
    }
}

export const getQuoteEventData = (
    event: OnboardingDataLayerEvent,
    formValues: OnboardingFormValues
) => {
    if (!OnboardingPostQuoteEvents.includes(event)) return {}

    return {
        ...formatProductAmount(formValues),
        ...formatProductCodes(formValues),
        ...formatInvoiceUploadSaving(formValues),
        quoted_provider_calendar_id: formValues.electricity.providerCalendarId,
        quoted_subscription_power: formValues.userInput.electricitySubscribedMaxPower,
        quote_code: formValues.quoteCode,
    }
}
